// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"bd275312","208":"bd9a07ec","774":"c0667a29","787":"8eed37f2","854":"0a9b5504","883":"42e845ed","992":"97354072"}[chunkId] + ".chunk.js";
};